import { Subject } from 'rxjs';
import { DoubleCube } from './interfaces';
import Color from '@base/features/game/model/color';
import { DoubleCubeData } from './types';
import GameStateImpl from './gameState';

export default class DoubleCubeImpl implements DoubleCube {
  onDoubleCubeChangedEvent = new Subject<DoubleCubeData>();
  crawford = false;
  noDouble = false;
  cubeValue = 64;
  cubeHolder?: Color;
  locked = false;
  maxScore = 0;

  constructor(private gameState: GameStateImpl) {}

  getCubeHolder() {
    if (!this.cubeHolder) throw new Error('No cube holder');
    this.emitDoubleCubeChangedEvent();
    return this.cubeHolder;
  }

  getCubeValue() {
    this.emitDoubleCubeChangedEvent();
    return this.cubeValue;
  }

  setRules(maxScore: number, crawford: boolean, noDouble: boolean) {
    this.maxScore = maxScore;
    this.crawford = crawford;
    this.noDouble = noDouble;
  }

  setLocked(locked: boolean) {
    if (locked === undefined) locked = true;
    this.locked = Boolean(locked);
  }

  setCubeState(cubeHolder: Color | undefined, cubeValue: number) {
    this.cubeHolder = cubeHolder;
    this.cubeValue = cubeValue;
    this.emitDoubleCubeChangedEvent();
  }

  isDoubleAllowed() {
    if (this.noDouble) return false;
    if (this.crawford && this.gameState.isCrawfordRound()) return false;
    if (this.gameState.maxPoints === 1) return false;
    return true;
  }

  isDoubleEnabled() {
    if (!this.isDoubleAllowed()) {
      return false;
    }
    if (this.locked) return false;
    if (this.cubeHolder === Color.reverseColor(this.gameState.getMyColor())) {
      return false;
    }
    if (this.maxScore === 1) {
      return false;
    }
    if (this.cubeValue === 32) {
      return false;
    }
    if (this.gameState.getDiceSum(Color.White) + this.gameState.getDiceSum(Color.Black) === 0) {
      return false;
    }
    return true;
  }

  emitDoubleCubeChangedEvent() {
    const cube: DoubleCubeData = {
      value: this.cubeValue,
      color: this.cubeHolder,
      active: this.gameState.canClickDoubleCube(),
    };
    this.onDoubleCubeChangedEvent.next(cube);
  }
}
